// extracted by mini-css-extract-plugin
export default {"offline_container":"Offline_offline_container__IfqFV","offline__body":"Offline_offline__body__wVB7v","background":"Offline_background__Ieo7Q"};